import { IInternalPresence } from '@dxp/core/models';
import { AgentState } from '@dxp/core/types';

export const calculateInternalUserPresence = (
    state: string,
): IInternalPresence => {
    return {
        label: internalStateToLabel(state),
        class: internalStateToClass(state),
        state: internalStateToAgentState(state),
    };
};

const internalStateToClass = (state: string): string => {
    switch (state.toLowerCase()) {
        case 'available':
        case 'availableidle':
            return 'success';
        case 'away':
        case 'berightback':
            return 'warning';
        case 'busy':
        case 'busyidle':
        case 'donotdisturb':
            return 'danger';
        case 'offline':
        case 'presenceunknown':
            return 'secondary';
        default:
            return state;
    }
};

const internalStateToLabel = (state: string): string => {
    switch (state.toLowerCase()) {
        case 'available':
        case 'availableidle':
            return 'Available';
        case 'away':
        case 'berightback':
            return 'Break';
        case 'busy':
        case 'busyidle':
        case 'donotdisturb':
            return 'Busy';
        case 'offline':
        case 'presenceunknown':
            return 'Logged Out';
        default:
            return state;
    }
};

const internalStateToAgentState = (state: string): AgentState => {
    switch (state.toLowerCase()) {
        case 'available':
        case 'availableidle':
            return 'Idle';
        case 'away':
        case 'berightback':
            return 'Break';
        case 'busy':
        case 'busyidle':
        case 'donotdisturb':
            return 'Busy';
        case 'offline':
        case 'presenceunknown':
            return 'LoggedOut';
        default:
            return 'LoggedOut';
    }
};
